import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

import { cn } from "@/lib/utils";

export const FormTextAreaInput = <T extends Record<string, unknown>>({
  fieldName,
  form,
  inputClassName,
  label,
  maxLength,
  optional,
  placeholder,
}: {
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  inputClassName?: string;
  label?: string;
  maxLength?: number;
  optional?: boolean;
  placeholder?: string;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        const value = (field.value as string) || "";
        return (
          <FormItem className="text-slate-700">
            {label && (
              <FormLabel>
                {label}
                {optional && <OptionalLabel className="ml-1.5" />}
              </FormLabel>
            )}
            <FormControl>
              <Textarea
                {...field}
                className={cn("text-slate-700", inputClassName)}
                maxLength={maxLength}
                placeholder={placeholder ?? "-"}
                value={value}
              />
            </FormControl>
            <Row className="items-center justify-between gap-2">
              <FormMessage />
              {maxLength != null && (
                <Text className="ml-auto text-xs font-normal text-slate-400">
                  {value.length}/{maxLength}
                </Text>
              )}
            </Row>
          </FormItem>
        );
      }}
    />
  );
};
